export default {
  'translation': {
    'waste_icon': {
      'alt_texts': {
        'WASTE_STREAM_ABS': 'Icoon voor ABS (afval breng station)',
        'WASTE_STREAM_PAPER': 'Icoon voor papier',
        'WASTE_STREAM_GFT': 'Icoon voor GFT (groente, fruit en tuin afval)',
        'WASTE_STREAM_PMD': 'Icoon voor plastic',
        'WASTE_STREAM_GLAS': 'Icoon voor glas',
        'WASTE_STREAM_REST': 'Icoon voor rest afval',
        'WASTE_STREAM_TEXTILE': 'Icoon voor textiel',
        'WASTE_STREAM_CLEAN': 'Icoon voor reinigen',
        'WASTE_STREAM_KRINGLOOP': 'Icoon voor kringloop'
      },
      'not_found': 'No icon for stream {{streamId}}'
    },
    'form': {
      'field': {
        'postal_code': {
          'label': 'Postcode',
          'placeholder': '1234 AB'
        },
        'house_number': {
          'label': 'Huisnummer',
          'placeholder': '123'
        },
        'house_number_extension': {
          'label': 'Toevoeging',
          'placeholder': '- Selecteer -',
          'empty': 'geen toevoeging'
        },
        'file_upload': {
          'size': {
            'description': 'Maximale bestandsgrootte is {{ maxSize }} MB',
            'error': 'Bestanden die groter dan {{ maxSize }} MB zijn kunnen niet geüpload worden.'
          },
          'type': {
            'description': 'Alleen {{ mimeTypes }} toegestaan',
            'error': 'Je kunt alleen {{ mimeTypes }} bestanden toevoegen.'
          },
          'amount': {
            'description_plural': 'Maximaal {{ maxAmount }} bestanden',
            'description_singular': 'Maximaal 1 bestand',
            'error_plural': 'Je kunt maximaal {{ maxAmount }} bestanden toevoegen.',
            'error_singular': 'Je kunt maximaal 1 bestand toevoegen.'
          },
          'error': 'Er is iets fout gegaan bij het uploaden van de bestanden.',
          'delete': 'Verwijder bestand'
        }
      },
      'textarea': {
        'maxChars': 'Max {{ maxCharacters }} tekens'
      },
      'optional': '- Optioneel',
      'error': {
        'required': 'Dit veld is verplicht',
        'invalid_postal_code': 'Vul een geldige postcode (vier cijfers en twee letters) in.',
        'message_prefix': 'Foutmelding'
      }
    },
    'copy_link': {
      'link_text': 'Kopieer link',
      'copied': 'De link is gekopieerd!'
    },
    'skiplink': {
      'skipLinkText': 'Overslaan en naar de inhoud gaan'
    },
    'dialog_modal': {
      'close': 'Sluiten'
    },
    'loading': 'Bezig met laden',
    'journey_overlay': {
      'close_button_text': 'stop aanvraag'
    },
    'information_overlay': {
      'close': 'Sluit de information overlay'
    },
    'customer_effort_score': {
      'labels': {
        'good': 'Goed',
        'bad': 'Slecht'
      },
      'scores': {
        '1': 'Zeer slecht',
        '2': 'Slecht',
        '3': 'Matig',
        '4': 'Goed',
        '5': 'Zeer goed'
      }
    },
    'pagination': {
      'next': 'Volgende',
      'previous': 'Vorige'
    }
  }
};